export const scrollToTop = () => {
  globalThis.scrollTo({ top: 0, left: 0, behavior: "smooth" });
};
